"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CountTo: _vueCountTo.default
  },
  props: {
    statMoney: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      delComma: _index.delComma,
      date_type: 5,
      device_data: [],
      colorPalette: (0, _index.colorPalette)(),
      abnormalInfo: [{}, {}],
      abnormal_type: this.checkRoles('terminal') ? 1 : 0,
      search_goods_type: 0,
      toDo: [],
      articleList: [],
      updateList: [],
      marquee_top: false,
      info: {},
      detailVisible: false,
      activeName: 'second'
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  mounted: function mounted() {
    this.getArticle();
    this.getArticle(4);
    this.getAbnormalData();
    this.getTodo();
  },
  methods: {
    /**
     * 获取公告
     */
    getArticle: function getArticle() {
      var _this = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var url = 'agentapi/article/public_list';
      this.$get(url, {
        article_type: type
      }).then(function (res) {
        if (type == 1) {
          _this.articleList = res.list;
          setInterval(function () {
            _this.showMarquee();
          }, 3000);
        } else {
          _this.updateList = res.list;
          setInterval(function () {
            _this.showMarquee('updateList');
          }, 3000);
        }
        _this.loadObj.close();
      });
    },
    /**
       * 文章详情
       */
    getDetail: function getDetail(row) {
      var _this2 = this;
      this.$get('agentapi/article/detail', {
        id: row.id
      }).then(function (res) {
        _this2.info = res.info;
        _this2.detailVisible = true;
      });
    },
    /**
       * 代办事宜
       */
    getTodo: function getTodo() {
      var _this3 = this;
      this.$get('agentapi/business/pending_items').then(function (res) {
        _this3.toDo = res;
      });
    },
    /**
     * 折线图统计
     */
    getStatistics: function getStatistics() {
      var _this4 = this;
      var date_type = this.date_type;
      this.$get('agentapi/my_statistics_data', {
        date_type: date_type
      }).then(function (res) {
        if (_this4.checkRoles(['terminal'])) {
          res.device_data.map(function (item) {
            switch (item.url) {
              case '/agent/index':
                return item.url = '/partner/index';
                break;
              case '/agent/subAgent':
                return item.url = '/partner/subAgent';
                break;
              case '/shop/index':
                return item.url = '/shop/subShop';
                break;
            }
          });
        }
        _this4.device_data = res.device_data;
      });
    },
    /**
       * 异常数据
       */
    getAbnormalData: function getAbnormalData() {
      var _this5 = this;
      this.$get('agentapi/business/entire_detection', {}).then(function (res) {
        _this5.abnormalInfo = [res.my_info, res.son_info];
        _this5.loadObj.close();
      });
    },
    /**
       * 跳转
       */
    jump: function jump(item) {
      window.sort_id_key = item.type == 1 ? item.goods_id : item.order_id;
      if (item.type == 1 && this.abnormal_type == 0) {
        this.$router.push({
          path: '/equipment/index',
          query: {
            'sort_id_key': true
          }
        });
      } else if (item.type == 1 && this.abnormal_type == 1) {
        this.$router.push({
          path: '/equipment/subEquipment',
          query: {
            'sort_id_key': true
          }
        });
      } else if (item.type == 2 && this.abnormal_type == 0) {
        this.$router.push({
          path: '/order/meOrder',
          query: {
            'sort_id_key': true
          }
        });
      } else if (item.type == 2 && this.abnormal_type == 1) {
        this.$router.push({
          path: '/order/subOrder',
          query: {
            'sort_id_key': true
          }
        });
      }
    },
    handleClick: function handleClick(tab, event) {
      this.abnormal_type = tab.index;
    },
    handleGoodsTypeClick: function handleGoodsTypeClick() {
      console.log(this.search_goods_type);
      // this.$get('agentapi/business/entire_detection', {search_goods_type: this.search_goods_type}).then(res => {
      //   this.abnormalInfo = [
      //     res.my_info,
      //     res.son_info
      //   ]
      // })
    },
    showMarquee: function showMarquee() {
      var _this6 = this;
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'articleList';
      this.marquee_top = true;
      setTimeout(function () {
        _this6[name].push(_this6[name][0]);
        _this6[name].shift();
        _this6.marquee_top = false;
      }, 500);
    }
  }
};